module.exports = __webpack_public_path__ + "img/faqs-icon.fcfe3502.svg";